/**
 * Occupation type numbers that require a purchaser (nabyvatel) to be selected.
 */
export const PERMANENT_WITH_PURCHASE: number[] = [1, 2, 8, 11, 111, 112, 113];
